import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Logo from "../../../Assets/images/logoh.png";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import { ShopCardStyle } from "./ShopCardStyle";
import { ShopCategory } from "../../../Cpanel/pages/ShopCategory";
import AvatarImage from "../../../Assets/images/download.png";
import BranchesLoc from "../../../Cpanel/Components/BranchesLoc";
export const ShopProfile = () => {
  const [shopData, setShopData] = useState([]);
  const [shopCategoryData, setShopCategoryData] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const { id } = useParams();
  const [langData, setLangData] = useState("");
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("shopid", id);
    fetchData("shopprofile", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setShopData(data);
    setShopCategoryData(data?.catdata);
  };
  const handlesetLatLong = (data) => {
    console.log(data, "lat");
    // const [lat, lng] = {...data}

    // console.log(lat,lng)
    setLangData(data);
  };
  const shopInfo = shopData?.data?.[0];
  return (
    <div className="mt-1 container">
      <div className="card wd-75 wm-100 mx-auto ">
        <div className="card-body">
              <Row className=" d-flex justify-content-between align-items-center  px-4">
                <Col className="col-12 col-lg-4">
                  <img
                    id="qrcode"
                    className="qrcode"
                    onClick={() => document.getElementById("fileInput").click()}
                    alt="avatar"
                    src={shopInfo?.MainLogo ? `${shopInfo?.MainLogo}` : Logo}
                  />
                </Col>
                <Col className="col-12 col-lg-4">
                  <h4 className="card-title  ">{shopInfo?.Title} </h4>
                </Col>
                <Col className="col-12 col-lg-4">
                  <Link to={`https://${shopInfo?.WebSite}?R=taab30`}>
                    <button className="btn btn-primary btn-xl px-3 ">
                      ورود به فروشگاه
                    </button>
                  </Link>
                </Col>
              </Row>

                <Row>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold">شماره تماس</label>
                      <label>{shopInfo?.Tel}</label>
                    </div>
                  </Col>
                  <Col className=" col-12 col-lg-4 ">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold"> کش بک</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                    </div>
                  </Col>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold">درباره فروشگاه</label>
                      <label>{shopInfo?.ShopDesc}</label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <label className="fw-bold">شبکه های اجتماعی</label>
                    <div className="m-2 pb-2  rounded  d-flex flex-row justiy-content-around align-items-center gap-2  lg:w-50">
                      <div></div>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <h3 className="">لوکیشن فروشگاه</h3>
                    <BranchesLoc
                      setLatLong={handlesetLatLong}
                      value={langData}
                    />
                </Row>
              </div>
      </div>
    </div>
  );
};
